import { jsx as _jsx } from "react/jsx-runtime";
import UIAlert from '../UIComponents/UIAlert';
import UIButton from '../UIComponents/UIButton';
import { CURRENT_USER_CALENDAR_MISSING } from './constants';
import { __ } from '@wordpress/i18n';
export default function MeetingWarning({ status, onConnectCalendar, }) {
    const isMeetingOwner = status === CURRENT_USER_CALENDAR_MISSING;
    const titleText = isMeetingOwner
        ? __('Your calendar is not connected.', 'leadin')
        : __('Calendar is not connected.', 'leadin');
    const titleMessage = isMeetingOwner
        ? __('Please connect your calendar to activate your scheduling pages.', 'leadin')
        : __('Make sure that everybody in this meeting has connected their calendar from the Meetings page in HubSpot.', 'leadin');
    return (_jsx(UIAlert, { titleText: titleText, titleMessage: titleMessage, children: isMeetingOwner && (_jsx(UIButton, { use: "tertiary", id: "meetings-connect-calendar", onClick: onConnectCalendar, children: __('Connect calendar', 'leadin') })) }));
}
